import { actionChannel, call, put, select, take } from 'redux-saga/effects';
import { DATA_SOURCE_IDS } from '@discover-frontend/constants';
import { FUSION_TYPES } from '@discover-frontend/constants';
import { getProductScope } from '@discover-frontend/utils';
import {
  GET_QUERY_MEMBERSHIP_FAILURE,
  GET_QUERY_MEMBERSHIP_REQUEST,
  GET_QUERY_MEMBERSHIP_SUCCESS,
} from '../constants/action-types';
import { clearQuery, removeEmptyBlocksFromQuery } from '../operations/query';
import {
  hasGwiFusion,
  hasWWGwiMediaFusion,
  hasMriSimmonsFusion,
  hasTgiFusion,
} from '../utils/AuthHelperMethods';
import sagaFetch from './SagaFetch';
import * as engineApi from '../services/engineApi';

function* fetchQueryMembership(action) {
  const { targetId, query } = action;
  const dataSource = yield select((state) => state.queryBuilder.dataSource);
  const newQuery = query.target_query
    ? removeEmptyBlocksFromQuery({ ...query.target_query }, false)
    : null;
  let audience = {
    query_type: query.query_type,
    label: query.target_label || query.label,
    target_query: newQuery ? clearQuery(newQuery) : null,
    base_query:
      query.base_query && query.base_query.query_block
        ? {
            whole_population: false,
            query_block: clearQuery(query.base_query.query_block),
          }
        : { whole_population: true, query_block: null },
    target_membership_id: query.target_membership_id,
  };

  if (audience.query_type !== 'interest') {
    audience = {
      ...audience,
      audience_timeframe: query.audience_timeframe,
      results_timeframe: query.results_timeframe || 52,
    };
  }
  const data = {
    ...audience,
  };
  data.scope = getProductScope();

  data.source = query.data_source || dataSource;

  if (data.source === DATA_SOURCE_IDS.TWITTER) {
    if (hasMriSimmonsFusion()) data.partner_source = FUSION_TYPES.MRI_SIMMONS;
    if (hasGwiFusion()) data.partner_source = FUSION_TYPES.GWI;
    if (hasWWGwiMediaFusion()) data.partner_source = FUSION_TYPES.WW_GWI_MED;
    if (hasTgiFusion()) data.partner_source = FUSION_TYPES.TGI;
  }

  const { response, error } = yield sagaFetch(
    engineApi.fetchMembershipApi,
    data
  );

  if (!error) {
    return yield put({
      type: GET_QUERY_MEMBERSHIP_SUCCESS,
      targetId,
      size: response.data && response.data.target_audience_size,
    });
  }

  return yield put({
    type: GET_QUERY_MEMBERSHIP_FAILURE,
    targetId,
    error,
  });
}

export function* membershipWatcher() {
  const requestChannel = yield actionChannel(GET_QUERY_MEMBERSHIP_REQUEST);
  while (true) {
    const action = yield take(requestChannel);
    yield call(fetchQueryMembership, action);
  }
}
